import { gql } from "graphql-request";
export const ALL_DKIS = gql`
    query allDkis {
        allDkis(isActive: true, type: "allowed") {
            type
            name
        }
    }
`;
